import { FormProvider, useForm } from "react-hook-form";
import { ManualTabFilters } from "./ManualTabFilters";
import { ManualTabTable } from "./ManualTabTable";
import { ManualTabControls } from "./ManualTabControls";
import { FC, useEffect } from "react";
import { useGetVacationYears } from "@hr/api/endpoints";
import { LoadingWrapper } from "@hr/common/LoadingState";
import { ManualTabGridRef } from "@hr/statisticsview/vacancy/ManualTab/ManualTab.types";

export interface VacationYearOption {
  id: number;
  annualVacationYear: string;
  vacancyYearStarted: string;
  vacancyYearEnded: string;
  annualVacationYearStatus: string;
  locked: string;
}

interface ManualTabFilters {
  organizationVacationYearId: number;
  start: string;
  end: string;
  paymentGroup?: string;
}

export const ManualTab: FC<{ gridRef: ManualTabGridRef }> = ({ gridRef }) => {
  const { data: vacationYears, isSuccess } = useGetVacationYears<VacationYearOption[]>();

  const form = useForm<ManualTabFilters>({
    mode: "onChange",
    defaultValues: {
      organizationVacationYearId: 0,
      start: "",
      end: "",
      paymentGroup: "",
    },
  });

  const makeCurrentYearDefault = () => {
    if (isSuccess && vacationYears && vacationYears.length > 0) {
      const currentYear = new Date().getFullYear();

      const defaultYear = vacationYears.find((year) => {
        const yearStart = new Date(year.vacancyYearStarted).getFullYear();
        const yearEnd = new Date(year.vacancyYearEnded).getFullYear();
        return currentYear >= yearStart && currentYear <= yearEnd;
      });

      if (defaultYear) {
        form.setValue("organizationVacationYearId", defaultYear.id);
        return;
      }

      form.setValue("organizationVacationYearId", vacationYears[0].id);
    }
  };

  useEffect(makeCurrentYearDefault, [isSuccess, vacationYears]);

  return (
    <>
      <FormProvider {...form}>
        <LoadingWrapper isLoading={!vacationYears}>
          {vacationYears && <ManualTabFilters vacationYears={vacationYears} />}
        </LoadingWrapper>
        <ManualTabControls gridRef={gridRef} />
        <ManualTabTable gridRef={gridRef} />
      </FormProvider>
    </>
  );
};
